<template>
  <button
    v-if="currentZipCode"
    aria-haspopup="dialog"
    :aria-label="'Change Zip Code ' + currentZipCode"
    class="link-body zipcode-button"
    @click="handleZipCodeSlideout"
  >
    {{ currentZipCode }}
  </button>
  <span
    v-else
    class="link-body"
    @click="handleZipCodeSlideout"
  >zip code</span>
</template>

<script setup>
import { nextTick } from 'vue';
import { useAvailabilityBigTicket } from '@modules/availability/composables';
import { useProduct } from '@modules/product';

defineProps({
  currentZipCode: {
    type: String,
    default: '',
  },
});

const { productId } = useProduct();
const {
  activeSlideout, zipcodeSlideoutShown, previouslyFocusedElement, toggleBTSlideOut,
} = useAvailabilityBigTicket();

const handleZipCodeSlideout = async () => {
  zipcodeSlideoutShown.value = true;
  activeSlideout.value = productId;
  previouslyFocusedElement.value = document.activeElement;
  await nextTick();
  toggleBTSlideOut(productId);
};
</script>
